module.exports = __webpack_public_path__ + "img/img_supplierLogo.062c5d6a.png";